import { api } from '@/lib/api.js';

// The commission view (deals-door-1 T17/T18, PLAN-FINAL 4.2, 4.3): GET /api/tracon/commissions, every signed-in
// person, read only. producer is me | unassigned | all; the closed-on range is whole months (YYYY-MM) exactly as typed:
// the server decides which days a month holds. Expected answers (handled on the page, never toasted by the shell):
// 400 mine_unavailable (the shared login has no "me"), 400 bad_request, 503 could_not_check (a failed or short read,
// never an empty view).
export function getCommissions({ producer, closedFromMonth, closedToMonth }) {
  const q = new URLSearchParams();
  if (producer) q.set('producer', producer);
  if (closedFromMonth) q.set('closed_from_month', closedFromMonth);
  if (closedToMonth) q.set('closed_to_month', closedToMonth);
  return api.get(`/api/tracon/commissions?${q.toString()}`, {
    expected: [
      { status: 400, code: 'mine_unavailable' }, { status: 400, code: 'bad_request' }, { status: 503, code: 'could_not_check' },
    ],
  });
}
